import { PlaceholderImage } from './components/sliders/components/SliderImages';
import './assets/css/image_gallery.css';
import ImagesLightboxModal from './ImagesLightboxModal';
import { useState } from 'react';

export default function PrimarySecondaryImageGallery({ images }) {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  return (
    <>
      <div className={'image_gallery'}>
        {images.slice(0, 5).map((src, index) => (
          <PlaceholderImage
            key={`Fishery image ${index + 1}`}
            src={src}
            alt={`Fishery image ${index + 1}`}
            className={'image_gallery__image'}
            onClick={() => setLightboxIndex(index)}
          />
        ))}
        {images.length > 5 && (
          <div
            className={'image_gallery__more_images_overlay'}
            onClick={() => setLightboxIndex(4)}
          >
            <span className={'txt-center white fs-30'}>
              +{images.length - 5}
            </span>
          </div>
        )}
      </div>
      <ImagesLightboxModal
        isOpen={lightboxIndex !== null}
        initialIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        images={images.map((src, index) => ({
          src,
          alt: 'Fishery image ' + (index + 1),
        }))}
        loading={!images}
      />
    </>
  );
}
